module.exports = __webpack_public_path__ + "img/time-rule.ce698541.svg";